<form [formGroup]="manualForm" class="mb-2" fxLayout="row" fxLayoutAlign="space-between center">
    <mat-checkbox formControlName="focus" (change)="setFocus(true,false)"></mat-checkbox>
    <mat-form-field fxFlex="1 1 auto%" class="ml-2">
        <mat-label>{{translate.getLng('ADDRESS')}}</mat-label>
        <!-- <input type="text"  #manuallocationSearch   senAppSearchDelay matInput (delayedInput)="googleTextSearchService()" (focus)="setFocus(true,false)" formControlName="street"> -->
        <input type="text"     senAppSearchDelay matInput (delayedInput)="googleTextSearchService()" formControlName="street">
    </mat-form-field>
        <mat-form-field class="ml-2" fxFlex="1 1 20%">
            <mat-label>{{translate.getLng('POSTAL_CODE')}}</mat-label>
            <!-- <input #manuallPostCodeSearch  type="text" senAppSearchDelay matInput (delayedInput)="googleTextSearchService()" (focus)="setFocus(true,false)" formControlName="postalCode"> -->
            <input   type="text" senAppSearchDelay matInput (delayedInput)="googleTextSearchService()"  formControlName="postalCode">

        </mat-form-field>
        <mat-form-field class="ml-2" fxFlex="1 1 25%">
            <mat-label>{{translate.getLng('LOCATION')}}</mat-label>
            <!-- <input #manuallCityCodeSearch type="text" senAppSearchDelay (delayedInput)="googleTextSearchService()" matInput (focus)="setFocus(true,false)" formControlName="location"> -->
            <input type="text" senAppSearchDelay (delayedInput)="googleTextSearchService()" matInput  formControlName="location">

        </mat-form-field>
        <mat-form-field class="ml-2" fxFlex="1 1 20%">
            <mat-label>{{translate.getLng('COUNTRY_ENGLISH')}}</mat-label>
            <mat-select senAppSearchDelay (delayedInput)="googleTextSearchService()" formControlName="countryISO">
                <mat-option *ngFor="let c of countryArray" [value]="c.iso2">
                    {{c.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
</form>
<p class="mb-2">{{translate.getLng('LATITUDE')}}: <b>{{latitude}}</b>, {{translate.getLng('LONGITUDE')}}: <b>{{longitude}}</b></p>
<form [formGroup]="googleForm" fxLayout="row" fxLayoutAlign="flex-start center">
    <mat-checkbox formControlName="focus" (change)="setFocus(false,true)"></mat-checkbox>
    <mat-form-field fxFlex="1 1 auto%" class="ml-2" id="googleMapLocationInput">
        <mat-label>{{translate.getLng('GOOGLE_LOCATION')}}</mat-label>
        <input matInput type="text" placeholder="{{translate.getLng('GOOGLE_LOCATION_PLACEHOLDER')}}" #locationSearch
            formControlName="googleLocation">
        <mat-icon matSuffix class="sen-active-color">location_on</mat-icon>
        <mat-icon matSuffix class="sen-active-color sen-cursor-pointer" (click)="resetLocationBar()">clear</mat-icon>
    </mat-form-field>
</form>

<div class="w-100 position-relative">
    
    <agm-map #agmMap [streetViewControl]="false" class="sen-address-modal w-100" [mapTypeId]="'hybrid'" [(zoom)]="zoom"
        [latitude]="latitude" [longitude]="longitude" (mapClick)="markerDragEnd($event)" [fullscreenControl]="true">
        <agm-marker [markerDraggable]="true" (dragEnd)="markerDragEnd($event)" [latitude]="latitude"
            [longitude]="longitude">
        </agm-marker>
    </agm-map>
</div>
<ng-container *ngIf="dialogRef">
    <button mat-raised-button class="mt-3 float-right px-4" color="primary"
        (click)="closeDialogue(true)">{{translate.getLng('OK')}}</button>
    <button mat-raised-button class="mt-3 float-right mr-3"
        (click)="closeDialogue(false)">{{translate.getLng('CANCEL')}}</button>
</ng-container>